import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { AtualizacaoConsumidorRequest, Types } from './types';

// ACTIONS
import {
	atualizacaoConsumidorSuccess,
	atualizacaoConsumidorFailure,
} from './actions';

function* atualizacaoConsumidorRequest(request: ReducerAction) {
	const { payload }: { payload: AtualizacaoConsumidorRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`consumidores/${CHANNEL}/consumidores-atualizacao`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(atualizacaoConsumidorSuccess(response));
	} else {
		yield put(atualizacaoConsumidorFailure(response));
	}
}

export default all([
	takeLatest(
		Types.ATUALIZACAO_CONSUMIDOR_REQUEST,
		atualizacaoConsumidorRequest,
	),
]);
